module.exports = __webpack_public_path__ + "static/media/editProject.97985316.svg";